import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Player } from '@movingimage-evp/player-library';
import { get } from 'lodash';

import { getPlayerAnalyticsConsentSelector } from 'common/selectors';
import { currentUserSelector } from 'common/selectors/currentUser';
import { mapToMiPlayerConfig } from './map-to-mi-player-config';
import { getFingerprint } from './get-fingerprint';
import { VideoPlaceholder } from '../video-placeholder';

export const MiPlayer = ({ playerConfiguration: oldPlayerConfig, playerId, videoId }) => {
  const resolvedLanguage = useTranslation().i18n.resolvedLanguage;
  const watermark = get(useSelector(currentUserSelector), 'watermark');
  const userGaveConsent = useSelector(getPlayerAnalyticsConsentSelector);
  const [playerConfig, setPlayerConfig] = useState(null);

  useEffect(() => {
    if (!oldPlayerConfig || !videoId) {
      return null;
    }

    const load = async () => {
      const visitorId = oldPlayerConfig.playerDefinition.analytics?.youbora?.enabled
        ? await getFingerprint()
        : undefined;

      const playerConfig = mapToMiPlayerConfig(
        oldPlayerConfig,
        playerId,
        videoId,
        resolvedLanguage,
        visitorId,
        watermark,
        userGaveConsent
      );
      setPlayerConfig(playerConfig);
    };

    // If the user has given or revoked consent, we can load the player
    if (userGaveConsent !== undefined) {
      load();
    }
  }, [oldPlayerConfig, playerId, videoId, resolvedLanguage, watermark, userGaveConsent]);

  return playerConfig ? <Player {...playerConfig} /> : <VideoPlaceholder />;
};
